(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mons-oct-header"]) return;
  try {
    
(() => {
  const setup = () => {
    const header = document.getElementById('MonsOctoberHeader');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = 'true';
    const cartLink=header.querySelector('.mo-cart');
    const notice=document.querySelector('[data-mo-cart-notice]');
    notice?.querySelector('[data-mo-cart-dismiss]')?.addEventListener('click',()=>notice.hidden=true);
    document.addEventListener('cart:update',async event=>{
      try{const response=await fetch(cartLink.getAttribute('href')+'.js',{credentials:'same-origin',cache:'no-store'});if(!response.ok)return;const cart=await response.json();const badge=cartLink.querySelector('[data-mo-cart-count]');badge.textContent=cart.item_count;badge.hidden=cart.item_count===0;if(event.detail?.data?.source==='product-form-component'&&!event.detail.data.didError&&notice)notice.hidden=false;}catch{}
    });
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 28);
    update();window.addEventListener('scroll', update, {passive:true});
    document.addEventListener('click', event => {
      const button = event.target.closest('[data-mo-open]');
      if(button){
        const dialog=document.getElementById(button.dataset.moOpen);
        if(!dialog)return;
        dialog.showModal();if(dialog.id==='MonsOctoberMenu')dialog.focus({preventScroll:true});button.setAttribute('aria-expanded','true');document.documentElement.style.overflow='hidden';
        if(!dialog.dataset.bound){dialog.dataset.bound='true';dialog.addEventListener('close',()=>{button.setAttribute('aria-expanded','false');document.documentElement.style.overflow='';button.focus();});}
      }
      const close=event.target.closest('[data-mo-close]');if(close)close.closest('dialog').close();
    });
    const groups = Array.from(document.querySelectorAll('.mo-nav-group'));
    const menu = document.getElementById('MonsOctoberMenu');
    const navigation = menu?.querySelector('.mo-navigation');
    const desktop = window.matchMedia('(min-width:1101px)');
    const sizePanel = () => {
      if (!desktop.matches || !menu.open) return;
      const panel = menu.querySelector('.mo-nav-group[open] .mo-nav-panel');
      navigation.style.setProperty('--mo-panel-space', (panel ? panel.offsetHeight + 38 : 0) + 'px');
    };
    if(desktop.matches && groups[0]) groups[0].open = true;
    groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
      event.preventDefault();
      const shouldOpen = desktop.matches || !group.open;
      groups.forEach(other => { other.open = other === group && shouldOpen; });
      requestAnimationFrame(sizePanel);
    }));
    const observer = new ResizeObserver(sizePanel);
    menu?.querySelectorAll('.mo-nav-panel').forEach(panel => observer.observe(panel));
    desktop.addEventListener('change', () => { groups.forEach((group,index) => group.open = desktop.matches && index === 0); requestAnimationFrame(sizePanel); });
    window.addEventListener('resize', sizePanel, {passive:true});
    document.querySelector('[data-mo-open="MonsOctoberMenu"]')?.addEventListener('click', () => requestAnimationFrame(sizePanel));
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup);else setup();
  document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mons-oct-home"] && !Shopify.designMode) return;
  try {
    
(() => {
 const setup = () => {
  document.querySelectorAll('.mo-home').forEach(home => {
   if(home.dataset.bound)return;home.dataset.bound='true';
   const track=home.querySelector('.mo-slides');const count=home.querySelector('[data-mo-count]');
   if(track){
    const reduced=matchMedia('(prefers-reduced-motion:reduce)');const hero=home.querySelector('.mo-hero');const pause=home.querySelector('[data-mo-pause]');let paused=reduced.matches;let timer;
    const move=delta=>{const index=Math.round(track.scrollLeft/track.clientWidth);track.scrollTo({left:((index+delta+track.children.length)%track.children.length)*track.clientWidth,behavior:reduced.matches?'instant':'smooth'})};
    const restart=()=>{clearInterval(timer);if(!paused&&track.children.length>1)timer=setInterval(()=>{if(!home.isConnected){clearInterval(timer);return}if(!document.hidden&&!document.querySelector('dialog[open]')&&!hero.matches(':hover')&&!hero.contains(document.activeElement))move(1)},5000)};
    home.querySelector('[data-mo-prev]')?.addEventListener('click',()=>{move(-1);restart()});home.querySelector('[data-mo-next]')?.addEventListener('click',()=>{move(1);restart()});
    const updatePause=()=>{pause?.setAttribute('aria-pressed',String(paused));if(pause)pause.textContent=paused?'▶':'Ⅱ'};
    pause?.addEventListener('click',()=>{paused=!paused;updatePause();restart()});updatePause();restart();
    track.addEventListener('scroll',()=>{if(count)count.textContent=`${Math.round(track.scrollLeft/track.clientWidth)+1} / ${track.children.length}`},{passive:true});
   }
   const more=home.querySelector('.mo-more-categories');more?.addEventListener('click',()=>{const expanded=more.getAttribute('aria-expanded')==='true';more.setAttribute('aria-expanded',String(!expanded));home.querySelector('.mo-categories').classList.toggle('is-expanded',!expanded);});
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();document.addEventListener('shopify:section:load',setup);
})();

  } catch(e) { console.error(e); }
})();
})();
